import React, { createContext, useReducer, useEffect } from 'react';

// Define the initial state
const initialState = {
    member_id: null,
    // other state properties...
};

// Create the context
const AppContext = createContext();

// Define a reducer function to handle state updates
const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_MEMBER_ID':
            return { ...state, member_id: action.payload };
        // handle other actions...
        default:
            return state;
    }
};

// Create a Context Provider component
const AppContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    // Check local storage for member_id and update the context state
    useEffect(() => {
        const storedUserData = localStorage.getItem('userData');
        if (storedUserData) {
            const parsedUserData = JSON.parse(storedUserData);
            console.log(parsedUserData)
            dispatch({ type: 'SET_MEMBER_ID', payload: parsedUserData.user_profile.member_id });
            // handle other state updates...
        }
    }, []); // Empty dependency array to run only once on component mount

    // ... (other state update logic)

    return (
        <AppContext.Provider value={{ state, dispatch }}>
            {children}
        </AppContext.Provider>
    );
};

// Create a custom hook for using the context
const useAppContext = () => React.useContext(AppContext);

export { AppContextProvider, useAppContext };
